import _ from 'lodash';
import { triggerDelayedResize } from './domUtils';
import YoutubeEmbed from './YoutubeEmbed';

import './tourStyles.scss';

// action calls a trigger delay resize to fix an issue/bug the tour has with the scroll bar
export const piOnboardingTourSteps = [
	{
		selector: '.nav-items-list',
		action: _.once(triggerDelayedResize),
		content: (
			<div className='onboarding-tour-step-container'>
				<h5>Get Started</h5>
				<p>
					Welcome! This is your navigation panel, from here
					you can go anywhere inside the app.
				</p>
			</div>
		)
	},

	{
		selector: '.studies-list-container',
		position: 'top',
		action: _.once(triggerDelayedResize),
		content: (
			<div className='onboarding-tour-step-container'>
				<h5>Coverage Analysis</h5>
				<p>
					Here you can find all of your coverage analysis
					and the current statuses of each study along with
					their respective information.
				</p>
			</div>
		)
	},
	{
		selector: '.study-state-selector',
		content: (
			<div className='onboarding-tour-step-container'>
				<h5>Filter your search</h5>
				<p>
					Filter your studies by their current status for
					efficient organization.
				</p>
			</div>
		)
	},
	{
		selector: '',
		style: { maxWidth: 'unset' },
		content: (
			<div className='tour-step-embed-video'>
				<h5>Need more help?</h5>
				<YoutubeEmbed embedId='in9oLADKNfs?si=B7w6JRc-PUYknbQO' />
			</div>
		)
	}
];

export const piStudyDetailsTourSteps = [
	{
		selector: '.alert-info',
		content: (
			<div>
				<h5>Different statuses</h5>
				<p>
					Here you can view the current status of your study
					along with the estimated time for completion.
				</p>
			</div>
		)
	},
	{
		selector: '.first-study-information-container',
		content: (
			<div>
				<h5>Study Information</h5>
				<p>
					Gain entry to the entirety of the study's
					information as documented during its initial
					creation.
				</p>
			</div>
		)
	},
	{
		selector: '.documents-data-header',
		content: (
			<div>
				<h5>Access to documents</h5>
				<p>
					You can conveniently access all documents that
					have been uploaded as part of the study, providing
					comprehensive insights and information at your
					fingertips.
				</p>
			</div>
		)
	},
	{
		selector: '.study-information-container',
		action: _.once(triggerDelayedResize),
		content: (
			<div>
				<h5>Everything you need to know</h5>
				<p>
					Gain access to the complete study information,
					with the ability to approve or edit details
					directly within the table.
				</p>
			</div>
		)
	}
];

export const piBillingGridTourSteps = [
	{
		selector: '[data-tour="billing-grid-tables"]',
		position: 'top',
		action: _.once(triggerDelayedResize),
		content: (
			<div className='billing-grid-tour-step-container'>
				<h5>Easy understanding</h5>
				<p>
					Easily navigate through the grid of the Billing
					grid to understand and review all healthcare
					expenses with clarity.
				</p>
			</div>
		)
	},
	{
		selector: '.request-review-button',
		action: triggerDelayedResize,
		position: 'top',
		content: (
			<div className='billing-grid-tour-step-container'>
				<h5>
					Uncertain about the details within the table?
				</h5>
				<p>
					Feel free to request a review, highlighting any
					inaccuracies for thorough examination and prompt
					correction of the information.
				</p>
			</div>
		)
	},
	{
		selector: '.pi-approval-button',
		position: 'left',
		content: (
			<div className='billing-grid-tour-step-container'>
				<h5>Approval</h5>
				<p>
					If you've verified that all information is
					accurate, approve the study to finish the study
					process.
				</p>
			</div>
		)
	}
];
